import * as types from './mutation-types'
import Ls from "@/services/ls";

export const loadWarehouses = ({ commit }) => {
    return new Promise((resolve, reject) => {
        window.axios.get('get/stores/collection')
            .then((response) => {
                commit(types.ADD_WAREHOUSES, response.data?.store);
                resolve(response)
            })
            .catch((err) => {
                reject(err)
            })
    })
}

export const loadScrollWarehouses = ({ commit, dispatch, state }, query) => {
    const params = new URLSearchParams({
        search: query.search || '',
        status: query.status || '',
        company: Ls.get('current.company')
    })

    let filter = params.toString()
    if(query.page) filter += `&page=${query.page}`

    return new Promise((resolve, reject) => {
        window.axios.get('get/stores/collection?'+filter).then((response) => {
            commit(types.ADD_SCROLL_WAREHOUSES_DATA, {data: response.data?.store, query: params.toString()})
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}


export const loadNextWarehouses = ({ commit, dispatch, state }, {search, filter}) => {
    let url = `get/stores/collection?filter=${filter}&search=${search}&after=${state.warehouseScroll.map(warehouse => warehouse.id)}`
    return new Promise((resolve, reject) => {
        window.axios.get(url).then((response) => {
            commit(types.ADD_NEXT_WAREHOUSES, response.data?.store)
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const updateWarehouse = ({ commit }, data) => {

    return new Promise((resolve, reject) => {
        window.axios.patch('update/' + data.id + '/store', data).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}


export const createWarehouse = ({ commit }, data) => {
    return new Promise((resolve, reject) => {
        window.axios.post('store/store', data).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}



export const deleteWarehouse = ({ commit }, id) => {
    return new Promise((resolve, reject) => {
        window.axios.delete('delete/' + id + '/store').then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const showWarehouse = ({ commit }, id) => {
    return new Promise((resolve, reject) => {
        window.axios.get('show/' + id + '/store').then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const loadUsersDoesNotHaveWarehouse = ({ commit, dispatch, state }, id) => {
    return new Promise((resolve, reject) => {
        window.axios.get(`get/user/${id}/store`,)
            .then((response) => {
                commit(types.ADD_USERS_NOT_HAVE_WAREHOUSES, response.data?.storeUsers);
                resolve(response)
            })
            .catch((err) => {
                reject(err)
            })
    })
}


export const addUsersToWarehouse = ({ commit }, data) => {
    return new Promise((resolve, reject) => {
        window.axios.post(`add/user/${data.store}/store`, data)
            .then((response) => {
                resolve(response)
            })
            .catch((err) => {
                reject(err)
            })
    })
}

export const updateUserRoleInWarehouse = ({ commit }, data) => {
    return new Promise((resolve, reject) => {
        window.axios.post('update/user/store', data)
            .then((response) => {
                resolve(response)
            })
            .catch((err) => {
                reject(err)
            })
    })
}

export const removeUserFromWarehouse = ({ commit }, data) => {
    return new Promise((resolve, reject) => {
        window.axios.delete(`delete/store/${data.store}/user/${data.user}`, { data })
            .then((response) => {
                resolve(response)
            })
            .catch((err) => {
                reject(err)
            })
    })
}

export const archiveWarehouse = ({ commit }, data) => {
    return new Promise((resolve, reject) => {
        window.axios.patch('archive/' + data.store + '/store', data).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const activeWarehouse = ({ commit }, data) => {
    return new Promise((resolve, reject) => {
        window.axios.patch('unarchive/' + data.store + '/store', data).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const updateProductToWarehouse = ({ commit }, data) => {
    return new Promise((resolve, reject) => {
        window.axios.patch(`update/product/${data.store}/store`, data)
            .then((response) => {
                resolve(response)
            })
            .catch((err) => {
                reject(err)
            })
    })
}

export const removeProductFromWarehouse = ({ commit }, data) => {
    return new Promise((resolve, reject) => {
        window.axios.delete(`delete/product/${data.store}/store`, { params: data })
            .then((response) => {
                resolve(response)
            })
            .catch((err) => {
                reject(err)
            })
    })
}

export const loadStoreProducts = ({ commit, dispatch, state }, id) => {
    return new Promise((resolve, reject) => {
        window.axios.get('get/stores/' + id + '/products/initialiaze')
            .then((response) => {
                commit(types.LOAD_STORE_PRODUCTS, response.data);
                resolve(response)
            })
            .catch((err) => {
                reject(err)
            })
    })
}
